/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NormalizeWithDecimalsLib,
  NormalizeWithDecimalsLibInterface,
} from "../NormalizeWithDecimalsLib";

const _abi = [
  {
    inputs: [],
    name: "DivisionResultIsZero",
    type: "error",
  },
];

const _bytecode =
  "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea264697066735822122018f8bc340bc93df04629235038c51b1c41751ef4dbdfe158d7b2489575467dbd64736f6c634300080d0033";

type NormalizeWithDecimalsLibConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NormalizeWithDecimalsLibConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NormalizeWithDecimalsLib__factory extends ContractFactory {
  constructor(...args: NormalizeWithDecimalsLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NormalizeWithDecimalsLib";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NormalizeWithDecimalsLib> {
    return super.deploy(overrides || {}) as Promise<NormalizeWithDecimalsLib>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): NormalizeWithDecimalsLib {
    return super.attach(address) as NormalizeWithDecimalsLib;
  }
  connect(signer: Signer): NormalizeWithDecimalsLib__factory {
    return super.connect(signer) as NormalizeWithDecimalsLib__factory;
  }
  static readonly contractName: "NormalizeWithDecimalsLib";
  public readonly contractName: "NormalizeWithDecimalsLib";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NormalizeWithDecimalsLibInterface {
    return new utils.Interface(_abi) as NormalizeWithDecimalsLibInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NormalizeWithDecimalsLib {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as NormalizeWithDecimalsLib;
  }
}
